import React from 'react';
import { SafeAreaView, Platform, StyleSheet } from 'react-native';
import { useTheme } from 'react-native-paper';
import { usePagination } from './usePagination';
import CustomButton from '../CustomButton/CustomButton';

const Pagination = props => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize,
    className
  } = props;

  const { colors } = useTheme()
  const styles = makeStyles(colors)

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize
  });

  // If there are less than 2 times in pagination range we shall not render the component
  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }

  const onNext = () => {
    if (currentPage + 1 > totalCount)
      return
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    if (currentPage - 1 < 1)
      return
    onPageChange(currentPage - 1);
  };


  let lastPage = paginationRange[paginationRange.length - 1];
  return (
    <SafeAreaView
      key={props.currentPage}
      style={styles.main}>
      {/* Left navigation arrow */}
      <CustomButton
        onPress={() => {
          onPrevious()
        }}
        iconName='arrow-back-circle-outline'
        show='NEXT_PAGE'
        type='NEXT_PAGE'
        textTop='0'
        sz={Platform.OS !== 'web' ? 20 : 25}
      />
      {paginationRange.map((pageNumber, index) => {
        // Render our Page Pills
        return (
          <SafeAreaView
            key={index}>
            <CustomButton
              onPress={() => {
                onPageChange(pageNumber)
              }}
              text={pageNumber}
              iconName='document-outline'
              show={pageNumber === currentPage ? 'HOME_SELECTED' : 'HOME'}
              type={pageNumber === currentPage ? 'HOME_SELECTED' : 'HOME'}
              textTop='0'
              sz={Platform.OS !== 'web' ? 20 : 25}
              pagination={true}
            />
          </SafeAreaView>
        );
      })}
      {/*  Right Navigation arrow */}
      <CustomButton
        onPress={() => {
          onNext()
        }}
        iconName='arrow-forward-circle-outline'
        show='NEXT_PAGE'
        type='NEXT_PAGE'
        textTop='0'
        sz={Platform.OS !== 'web' ? 20 : 25}
      />
    </SafeAreaView>
  );
};

const makeStyles = (colors) => StyleSheet.create({
  main: {
    flex:1,
    flexDirection: 'row',
    justifyContent: 'center',
    margin: 20,
  },
});

export default Pagination;